export default {
  rowSelection: false,
  fieldControl: false,
  // searchFormConfig:false,
  searchFormConfig: {
    labelCol: {
      xs: {span: 24},
      sm: {span: 8},
      xl: {span: 10},
    },
    wrapperCol: {
      xs: {span: 24},
      sm: {span: 16},
      xl: {span: 14},
    },
  },
  // scroll: {y: 350},
  columns: [
    {
      title: '使用分公司',
      dataIndex: 'companyName',
      width: 180,
      ellipsis: true,
      fixed: 'left',
    },
    {
      title: '使用人',
      dataIndex: 'claimUserName',
      width: 180,
      ellipsis: true,
      render: 'claimUser',
    },
    {
      title: '生活家账号',
      dataIndex: 'appuid',
      width: 160,
      ellipsis: true,
    },
    {
      title: '酷家乐账号',
      dataIndex: 'kjlAccount',
      width: 160,
      ellipsis: true,
    },
    {
      title: '酷家乐账号名称',
      dataIndex: 'appName',
      width: 160,
      ellipsis: true,
    },
    {
      title: '领用时间',
      dataIndex: 'startDate',
      width: 160,
      itemType: 'dateTime'
    },
    {
      title: '释放时间',
      dataIndex: 'endDate',
      width: 160,
      itemType: 'dateTime'
    },
  ],
  search: [
    {
      name: 'companyCode',
      label: '公司',
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'companies',
      addonOpts: [],
      showSearch: true,
      optionFilterProp: 'name'
    },
    {
      name: 'claimUserName',
      label: '领取人',
    },
    {
      name: 'appuid',
      label: '生活家账号',
    },
    {
      name: 'kjlAccount',
      label: '酷家乐账号',
    },
    {
      name: 'appName',
      label: '酷家乐账号名称',
    },
  ],
  footer: [
    // {
    //   label: '导出',
    //   type: 'primary',
    //   status: ['loading:exportLoading'],
    //   // auth: 'userRecordExportBtn',
    //   events: ['onClick:onExport'],
    // },
  ],
};
